import React from "react";
import formatDate from "helpers/format-date";
import { useSelector, useDispatch } from "react-redux";
import { getDayName } from "helpers/format-date";
import { billingToDeliveryDate } from "utils/subscription-date";
import obtainOrderInfo from "utils/obtain-order-info";
import { useGlobalContext } from "context/global";
import { ReactComponent as Calendar } from "assets/svgs/calendar.svg";
import { TOGGLE_SCHEDULED_ORDERS_MODAL, TOGGLE_RESCHEDULE_MODAL } from "utils/action-types";
import navigate from "helpers/navigate";
import { subscriptionPageUrl } from "utils/constants";

const BillingCycle = ({ cycle }) => {
	const { translation, language } = useGlobalContext();
	const { totalWeight, nextBillingDate, chargeOffsetDays } = useSelector((state) => state.account.subscription);
	const { latestSubOrder } = useSelector(state => state.account.profile);
	const isNextOrder = nextBillingDate === cycle.billingDate;
	const { date, show } = obtainOrderInfo(nextBillingDate, chargeOffsetDays, latestSubOrder);

	//Display delivered order date instead of billing date
	const delivery_date = billingToDeliveryDate(cycle.billingDate, chargeOffsetDays);
	const today = new Date();
	const hours = today.getHours();

	//At 10:45, an order initiation process takes place on Shopify. Loop is still returning this date,
	// but we dont need to show on frontend because users can skip the order if we show it
	if (new Date(delivery_date).toDateString() === new Date(date).toDateString() === today.toDateString() &&
		((hours === 10) && (hours === 10 && today.getMinutes() > 45)))
		return <></>;

	return (
		<div className="flex flex-col border-t border-gray-200 p-4 w-full md:px-8 gap-3 my-2 group">
			{(isNextOrder && !show) && (
				<div className="text-[#108610]">
					<span>{translation.subscription?.next_order}</span>
				</div>
			)}
			<div className="flex flex-col">
				<span>{getDayName(delivery_date, language)}, {formatDate(delivery_date, language)}</span>
				<span className="text-gray-500">
					{totalWeight} {totalWeight > 1 ? translation.cart?.products : translation.cart?.product}
					<br></br>
				</span>
			</div>
			{isNextOrder && <RescheduleButton />}
		</div>
	);
};

const RescheduleButton = () => {
	const { translation } = useGlobalContext();
	const { shippingAddress } = useSelector((state) => state.account.subscription);
	const { defaultAddress } = useSelector((state) => state.account.profile);
	const countryCode = defaultAddress?.countryCodeV2 || shippingAddress?.countryCode;

	const dispatch = useDispatch();

	const openCalendar = () => {
		if (!countryCode) {
			dispatch({ type: TOGGLE_SCHEDULED_ORDERS_MODAL });
			return navigate(subscriptionPageUrl);
		}

		dispatch({ type: TOGGLE_RESCHEDULE_MODAL });
	};

	return (
		<div className="flex justify-between flex-wrap gap-3">
			<button className="flex gap-2 rounded-[40px] border px-3 py-1.5 border-slate-300" onClick={openCalendar}>
				<Calendar className="inline-flex w-6" />
				{translation.subscription?.change_delivery_date}
			</button>
		</div>
	);
};

export default BillingCycle;
